import { AntDesign } from "@expo/vector-icons";
import { Pressable } from "react-native";
import { Colors } from "react-native-ui-lib";

export interface BarcodeComponentProps {
  onPress?: () => void;
}

export function BarcodeComponent({ onPress }: BarcodeComponentProps) {
  return (
    <Pressable onPress={onPress}>
      <AntDesign name="barcode" size={24} color={Colors.Text} />
    </Pressable>
  );
}
